import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type DeactivateUserModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function CheckConflictModal(props: DeactivateUserModalProps) {
  const { t } = useTranslation();
  const { isOpen, isLoading, onConfirm, onCancel } = props;

  return (
    <Modal isOpen={isOpen} testID="check-conflict-modal">
      <Dialog>
        <DialogHeader onClose={props.onCancel}>
          {t("Update checks")}
        </DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            <Trans>
              This bundled deal contains checks that are already in your cart.
              Adding this deal will replace existing checks with the options
              specified in this bundle.
            </Trans>
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton size="medium" onPress={onCancel} testID="cancel-button">
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="confirm-button"
          >
            <Trans>Got it</Trans>
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
